import React, { Component } from 'react';

import { Modal, ModalOpen, ModalClose } from '../Modal';
import { AUAContainer } from '../AUA';
import { T } from '../traks';
import { setPremiumLink } from '../misc';

function NotPremiumModalInit() {
	ModalOpen("NotPremiumModal");
}

class NotPremiumInnerContent extends Component {
    constructor(props) {
		super(props);

        const { aua } = this.props;

        if (aua.me && aua.me.Subscription.includes('pro', 'enterprise')) {
            ModalClose()
        }
	}

    

    render() {
        const goto_new_game = () => {
            ModalClose();
        }

        return (
            <div className="ad_trade_bg p-4">
                <div>
                    <T>You're try to active premium feature.</T>
                </div>
                <div className="mt-2">
                    <a on_click={goto_new_game} href={setPremiumLink()} className="ad_no_hover ad_new_game_button ad_rbtn_25px py-2 px-5"><T>Upgrade to premium</T></a>
                </div>
            </div>
        )
    }
}

const NotPremiumInner = (props) => <AUAContainer><NotPremiumInnerContent {...props}/></AUAContainer>;

class NotPremiumModal extends Modal {
    allow_close_via_ui() {
		return true;
	}

	mrender() {
		return <NotPremiumInner {...this.props}/>;
	}

	get_name() {
		return "NotPremiumModal";
	}

	get_fullscreen_bg_class() {
		return "ad_signuplogin_dark";
	}

	get_bootstrap_modal_class() {
		return "ad_trade_modal";
	}
}

export {
	NotPremiumModal,
	NotPremiumModalInit,
};


// WEBPACK FOOTER //
// ./src/c/NotPremiumModal.js